import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient, HttpParams} from "@angular/common/http";
import {contextPath} from "site";
import {AvCloudUser} from "../av-cloud-user";

const apiUrl = `${contextPath}/api/v2/users`;

/**
 * Service which calls UserApis.
 */
@Injectable()
export class UserService {

	constructor(private http: HttpClient) {}

	/**
	 * Observable which calls the getUserByCustomerGuid
	 * NOTE: Method name is getUserByCustomerGuid, albeit we are not passing customerGuid here is only to match the method name in "api/v2/users/current".
	 * This method is internal to FLy and calls UserController - getCurrentUserByCustomerGuid(). There we are getting customerGuid from logged in user via
	 * getUserFromOAuthOrSession(authorization)
	 * Return Observable of {@link User} Object
	 */
	getUserByCustomerGuid(): Observable<AvCloudUser> {
		return this.http.get<AvCloudUser>(`${apiUrl}/current`)
			.map(response => AvCloudUser.fromJSON(response));
	}

	/**
	 * Observable which calls the users endpoint with the provided customer GUID.
	 * @param customerGuid Nullable. Value to set the AircraftUuid query parameter in the request.
	 */
	getUserFromCustomerGuid(customerGuid: string): Observable<AvCloudUser> {
		let params = new HttpParams()
		if (customerGuid != null) {
			params = params.set('customerGuid', customerGuid.toString());
		}
		return this.http.get<AvCloudUser>(`${apiUrl}/${customerGuid}`, {params})
			.map(response => AvCloudUser.fromJSON(response));
	}
}
